import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex justify-space-between mb-2 text-caption" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "text-h6 font-weight-bold message-btn" }
const _hoisted_7 = { class: "text-h6 font-weight-bold message-btn" }
const _hoisted_8 = { class: "text-body-2 font-weight-bold message-btn" }
const _hoisted_9 = { class: "text-body-2 font-weight-bold message-btn" }
const _hoisted_10 = { class: "text-body-2 font-weight-bold message-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ChildOtherRecordListVue = _resolveComponent("ChildOtherRecordListVue")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_VueLoading = _resolveComponent("VueLoading")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_DefecationModal = _resolveComponent("DefecationModal")!
  const _component_TemperatureModal = _resolveComponent("TemperatureModal")!
  const _component_MilkModal = _resolveComponent("MilkModal")!
  const _component_SleepModal = _resolveComponent("SleepModal")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.fetchLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (child, index) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: index,
                  class: "mb-4"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createTextVNode(_toDisplayString(child.lastName) + " " + _toDisplayString(child.firstName) + " ", 1),
                      _createElementVNode("div", null, [
                        _createVNode(_component_v_btn, {
                          color: "secondary",
                          class: "mr-3",
                          variant: "outlined",
                          size: "x-small",
                          onClick: ($event: any) => (_ctx.clickToParentsRecord(child))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('records.parentsRecordTitle')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          variant: "outlined",
                          size: "x-small",
                          onClick: ($event: any) => (_ctx.clickDialog(child))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('records.addRecord')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    _createVNode(_component_ChildOtherRecordListVue, {
                      classOtherReport: _ctx.classOtherReport,
                      child: child,
                      onChangeDefecation: _ctx.changeDefecationModal,
                      onChangeTemperature: _ctx.changeTemperatureModal,
                      onChangeMilk: _ctx.changeMilkModal,
                      onChangeSleep: _ctx.changeSleepModal
                    }, null, 8, ["classOtherReport", "child", "onChangeDefecation", "onChangeTemperature", "onChangeMilk", "onChangeSleep"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_VueLoading, { height: '50vh' })
        ])),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isRecordDialog,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isRecordDialog) = $event)),
      "max-width": "720",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-center justify-center" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('records.addRecordTitle')), 1)
              ]),
              _: 1
            }),
            (_ctx.inputChild)
              ? (_openBlock(), _createBlock(_component_v_card_subtitle, {
                  key: 0,
                  class: "pt-2 d-flex align-center justify-center"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.inputChild.lastName) + " " + _toDisplayString(_ctx.inputChild.firstName), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                  modelValue: _ctx.otherRecord,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.otherRecord) = $event)),
                    _cache[1] || (_cache[1] = ($event: any) => (_ctx.recordedAt = ''))
                  ],
                  row: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_v_radio, {
                        label: _ctx.$t('records.temperature'),
                        value: "temperature"
                      }, null, 8, ["label"]),
                      _createVNode(_component_v_radio, {
                        label: _ctx.$t('records.milk'),
                        value: "milk"
                      }, null, 8, ["label"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_v_radio, {
                        label: _ctx.$t('records.defecation'),
                        value: "defecation"
                      }, null, 8, ["label"]),
                      _createVNode(_component_v_radio, {
                        label: _ctx.$t('records.sleep'),
                        value: "sleep"
                      }, null, 8, ["label"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.otherRecord === 'defecation')
                  ? (_openBlock(), _createBlock(_component_DefecationModal, {
                      key: 0,
                      recordedAt: _ctx.recordedAt,
                      "onUpdate:recordedAt": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.recordedAt) = $event)),
                      state: _ctx.state,
                      "onUpdate:state": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state) = $event))
                    }, null, 8, ["recordedAt", "state"]))
                  : _createCommentVNode("", true),
                (_ctx.otherRecord === 'temperature')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.inputChild)
                        ? (_openBlock(), _createBlock(_component_TemperatureModal, {
                            key: 0,
                            inputChild: _ctx.inputChild,
                            recordedAt: _ctx.recordedAt,
                            "onUpdate:recordedAt": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.recordedAt) = $event)),
                            temperature: _ctx.temperature,
                            "onUpdate:temperature": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.temperature) = $event)),
                            onChangeRecordedAt: _ctx.changeRecordedAt,
                            onChangeTemperature: _ctx.changeTemperature
                          }, null, 8, ["inputChild", "recordedAt", "temperature", "onChangeRecordedAt", "onChangeTemperature"]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.otherRecord === 'milk')
                  ? (_openBlock(), _createBlock(_component_MilkModal, {
                      key: 2,
                      recordedAt: _ctx.recordedAt,
                      "onUpdate:recordedAt": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.recordedAt) = $event)),
                      amount: _ctx.amountId,
                      "onUpdate:amount": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.amountId) = $event)),
                      milkCategory: _ctx.milkCategory,
                      "onUpdate:milkCategory": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.milkCategory) = $event))
                    }, null, 8, ["recordedAt", "amount", "milkCategory"]))
                  : _createCommentVNode("", true),
                (_ctx.otherRecord === 'sleep')
                  ? (_openBlock(), _createBlock(_component_SleepModal, {
                      key: 3,
                      from: _ctx.from,
                      "onUpdate:from": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.from) = $event)),
                      to: _ctx.to,
                      "onUpdate:to": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.to) = $event))
                    }, null, 8, ["from", "to"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "mt-2 mb-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "pr-2 pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "",
                          color: "#6C6C6C",
                          dark: "",
                          variant: "flat",
                          width: "100%",
                          onClick: _ctx.clickCancel
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('common.cancel')), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "pl-1 pr-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "",
                          color: "primary",
                          variant: "flat",
                          width: "100%",
                          onClick: _ctx.saveOtherRecord,
                          disabled: !_ctx.isSaveOtherRecord,
                          loading: _ctx.btnLoading
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('common.save')), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.isChangeRecordDialog,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.isChangeRecordDialog) = $event)),
      "max-width": "720",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "align-center justify-center" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('records.editDeleteRecord')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, {
              class: _normalizeClass({ 'edit-record-card-text': _ctx.$i18n.locale === 'en' })
            }, {
              default: _withCtx(() => [
                (_ctx.inputDefecation)
                  ? (_openBlock(), _createBlock(_component_DefecationModal, {
                      key: 0,
                      defecationTemp: _ctx.inputDefecation,
                      recordedAt: _ctx.recordedAt,
                      "onUpdate:recordedAt": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.recordedAt) = $event)),
                      state: _ctx.state,
                      "onUpdate:state": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state) = $event))
                    }, null, 8, ["defecationTemp", "recordedAt", "state"]))
                  : _createCommentVNode("", true),
                (_ctx.inputTemperature)
                  ? (_openBlock(), _createBlock(_component_TemperatureModal, {
                      key: 1,
                      temperatureTemp: _ctx.inputTemperature,
                      recordedAt: _ctx.recordedAt,
                      "onUpdate:recordedAt": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.recordedAt) = $event)),
                      temperature: _ctx.temperature,
                      "onUpdate:temperature": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.temperature) = $event)),
                      onChangeRecordedAt: _ctx.changeRecordedAt,
                      onChangeTemperature: _ctx.changeTemperature
                    }, null, 8, ["temperatureTemp", "recordedAt", "temperature", "onChangeRecordedAt", "onChangeTemperature"]))
                  : _createCommentVNode("", true),
                (_ctx.inputMilk)
                  ? (_openBlock(), _createBlock(_component_MilkModal, {
                      key: 2,
                      milkTemp: _ctx.inputMilk,
                      recordedAt: _ctx.recordedAt,
                      "onUpdate:recordedAt": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.recordedAt) = $event)),
                      amount: _ctx.amountId,
                      "onUpdate:amount": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.amountId) = $event)),
                      milkCategory: _ctx.milkCategory,
                      "onUpdate:milkCategory": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.milkCategory) = $event))
                    }, null, 8, ["milkTemp", "recordedAt", "amount", "milkCategory"]))
                  : _createCommentVNode("", true),
                (_ctx.inputSleep)
                  ? (_openBlock(), _createBlock(_component_SleepModal, {
                      key: 3,
                      sleepTemp: _ctx.inputSleep,
                      from: _ctx.from,
                      "onUpdate:from": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.from) = $event)),
                      to: _ctx.to,
                      "onUpdate:to": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.to) = $event))
                    }, null, 8, ["sleepTemp", "from", "to"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "mt-2 mb-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "4",
                      class: "pr-1 pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "",
                          color: "#6C6C6C",
                          dark: "",
                          variant: "flat",
                          width: "100%",
                          onClick: _ctx.clickCancel
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('common.cancel')), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "4",
                      class: "pl-1 pr-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "",
                          color: "error",
                          variant: "outlined",
                          width: "100%",
                          onClick: _ctx.removeRecord,
                          loading: _ctx.btnRemoveLoading
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('common.delete')), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "4",
                      class: "pl-1 pr-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "",
                          color: "primary",
                          variant: "flat",
                          width: "100%",
                          onClick: _ctx.changeOtherRecord,
                          loading: _ctx.btnLoading,
                          disabled: !_ctx.isSaveOtherRecord
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('common.save')), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}